<template>
  <div class="module-page">
    <gameInfoTitle title="模組資訊"></gameInfoTitle>
    <div class="module-detail">
      <table class="module-grid">
        <tr class="module-grid-cell">
          <td class="module-grid-cellImg" colspan="2">
            <div class="img-wrap">
              <gameObjCard
                :type="5"
                :hasName="false"
                :src="detailData.src"
                :quality="detailData.quality"
                :sourceBgType="detailData.IconType"
              >
              </gameObjCard>
            </div>
          </td>
        </tr>
        <tr class="module-grid-cell">
          <td class="module-grid-cellNormal" colspan="2">
            <div class="text-cell-wrap">
              <div class="text-cell">
                <p class="text-cell1">名稱:</p>
                <p class="text-cell2">{{ detailData.modeleName || "-" }}</p>
              </div>
              <div class="text-cell">
                <p class="text-cell1">增加的模組等擊:</p>
                <p class="text-cell2">
                  {{ detailData.addModuleLevel || "-" }}
                </p>
              </div>
            </div>
          </td>
        </tr>
        <tr class="module-grid-cell" v-for="(item,index) in detailData.levelInfo">
          <td class="module-grid-cellNormal" colspan="2">
            <div class="text-cell-wrap">
              <div class="text-cell">
                <p class="text-cell1">Lv:{{ item.level }}</p>
                <p class="text-cell2" v-html="item.content || '-'"></p>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="module-desc">
      <div class="module-desc-grid">
        <div class="module-desc-grid-cell1">
          <p>獲取方式</p>
        </div>
        <div class="module-desc-grid-cell2">
          <p>{{ detailData.gain || "-" }}</p>
        </div>
        <div class="module-desc-grid-cell3">
          <p>相關描述</p>
        </div>
        <div class="module-desc-grid-cell4">
          <p>{{ detailData.desc || "-" }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gameInfoTitle from "../components/gameInfoTitle.vue";
import gameObjCard from "../components/base/gameObjCard.vue";
export default {
  components: { gameInfoTitle, gameObjCard },
  props: {
    detailData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.module-page {
  .module-detail {
    margin-top: 0.12rem;

    .module-grid {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      margin-top: 0.01rem;
      margin-bottom: 0.3rem;

      &-cellImg {
        width: 100%;
        height: 1.6rem;
        border-color: black;
        border-style: solid;
        border-width: 1px;

        .img-wrap {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &-cell:nth-child(odd) {
        background-color: #f2f2f4;
      }

      &-cellNormal,
      &-cellSkill,
      &-cellSkill2 {
        border-color: black;
        border-style: solid;
        border-width: 1px;

        .text-cell-wrap {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .text-cell {
            flex: 1;
            padding: 0 0.2rem;
            display: flex;
            font-size: 0.22rem;
            align-items: center;
            justify-content: center;
            line-height: 0.48rem;
          }

          .text-cell1 {
            font-weight: 600;
            margin-right: 0.2rem;
          }

          .text-cell2 {
            flex: 1;
            color: #404040;
          }
        }
      }

      &-cellNormal {
        height: 0.55rem;
      }

      &-cellSkill {
        height: 0.55rem;

        .skill-icon {
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 1.06rem;
            height: 1.06rem;
            object-fit: contain;
          }
        }

        .skill-info-icon {
          border-color: black;
          border-style: solid;
          border-width: 1px;
        }

        .skill-info-attr {
          height: 0.55rem;
        }
        .text-cell1 {
          font-size: 0.24rem;
        }
        .text-cell2 {
          font-size: 0.22rem;
        }
      }

      &-cellSkill2 {
        height: 1.22rem;

        .skill-info-desc {
          padding: 0.22rem;
          background-color: #f2f2f4;
        }
        .text-cell1 {
          font-size: 0.24rem;
        }
        .text-cell2 {
          font-size: 0.22rem;
        }
      }
    }
  }

  .module-desc {
    width: 100%;

    .module-desc-grid {
      display: grid;
      height: 2.3rem;
      border: 0.01rem solid #d2d5da;
      grid-template-rows: repeat(5, 1fr);
      grid-template-areas:
        "cell1"
        "cell2"
        "cell3"
        "cell4"
        "cell4";

      &-cell1 {
        display: flex;
        align-items: center;
        justify-content: center;
        grid-area: cell1;
        background-color: #d2d5da;
        padding: 0 0.2rem;

        p {
          font-size: 0.24rem;
          font-weight: bold;
        }
      }

      &-cell2 {
        grid-area: cell2;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          color: #404040;
          font-size: 0.22rem;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        background-color: white;
        padding: 0 0.2rem;
      }

      &-cell3 {
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          font-weight: bold;
          font-size: 0.24rem;
        }

        grid-area: cell3;
        background-color: #d2d5da;
        padding: 0 0.2rem;
      }

      &-cell4 {
        p {
          color: #404040;
          font-size: 0.22rem;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        display: flex;
        align-items: center;
        justify-content: center;
        grid-area: cell4;
        background-color: white;
        padding: 0 0.2rem;
      }
    }
  }
}
</style>
